import { useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Loader } from '@altermaind/web/ui';
import { AlertBadge } from '@/_shared/components';
import { getEmployeesStatsCall } from '@/people/state';
import { getDepartmentsCall } from '../../state';
import { DepartmentsList } from '../DepartmentsList';
import { EmptyStateNoDepartments } from '../EmptyStateNoDepartments';
import { EmptyStateNoPeople } from '../EmptyStateNoPeople';
import { UnassignedMembers } from '../UnassignedMembers';

export const DepartmentsIntro = () => {
  const tShared = useTranslations();

  const {
    execute: executeGetDepartments,
    loading: loadingGetDepartments,
    error: errorGetDepartments,
    success: successGetDepartments,
    departmentsToShowCount,
    hasUnknownDepartment,
  } = getDepartmentsCall.hook();

  const {
    execute: executeGetEmployeesStats,
    success: successGetEmployeesStats,
    error: errorGetEmployeesStats,
    loading: loadingGetEmployeesStats,
    completed,
  } = getEmployeesStatsCall.hook();

  useEffect(() => {
    executeGetDepartments({});
    executeGetEmployeesStats({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loadingGetDepartments || loadingGetEmployeesStats) {
    return (
      <Box mt='s' textAlign='center'>
        <Loader size='s' />
      </Box>
    );
  }

  if (errorGetDepartments || errorGetEmployeesStats) {
    const message = tShared('errors.genericApiError');
    return <AlertBadge containerProps={{ mt: 's' }} iconName='info' type='error' label={message} />;
  }

  if (successGetDepartments && successGetEmployeesStats) {
    if (completed === 0) {
      return <EmptyStateNoPeople />;
    }
    if (departmentsToShowCount === 0) {
      /*
       * There are complete records, but no department has been registered:
       * the profiles exist, but they do not contain any department information.
       */
      return <EmptyStateNoDepartments />;
    }
    return (
      <Box>
        {departmentsToShowCount > 0 && <DepartmentsList />}
        {hasUnknownDepartment && <UnassignedMembers />}
      </Box>
    );
  }

  return null;
};
